var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5124",
    "data-name": "Group 5124",
    transform: "translate(-632 -529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(632 529)",
    fill: "#fff",
    stroke: "#00408a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info",
    "data-name": "Icon awesome-info",
    d: "M.4,8.5H.8v-2.9H.4a.4.4,0,0,1-.4-.4V4.249a.4.4,0,0,1,.4-.4H2.645a.4.4,0,0,1,.4.4V8.5h.4a.4.4,0,0,1,.4.4V9.86a.4.4,0,0,1-.4.4H.4a.4.4,0,0,1-.4-.4V8.9A.4.4,0,0,1,.4,8.5ZM1.924,0A1.443,1.443,0,1,0,3.367,1.443,1.443,1.443,0,0,0,1.924,0Z",
    transform: "translate(638.272 531.27)",
    fill: "#00408a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowInfoIcon);
export default __webpack_public_path__ + "static/media/showInfoIcon.6350c9406af7f3f8ea37031aef1af2f5.svg";
export { ForwardRef as ReactComponent };